// source: accounts/protos/session.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */


var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var accounts_protos_user_dto_pb = require('../../accounts/protos/user_dto_pb.js');
goog.object.extend(proto, accounts_protos_user_dto_pb);
var accounts_protos_pangolin_dto_pb = require('../../accounts/protos/pangolin_dto_pb.js');
goog.object.extend(proto, accounts_protos_pangolin_dto_pb);
var accounts_protos_payment_dto_pb = require('../../accounts/protos/payment_dto_pb.js');
goog.object.extend(proto, accounts_protos_payment_dto_pb);
var accounts_protos_invoice_dto_pb = require('../../accounts/protos/invoice_dto_pb.js');
goog.object.extend(proto, accounts_protos_invoice_dto_pb);
var accounts_protos_plan_dto_pb = require('../../accounts/protos/plan_dto_pb.js');
goog.object.extend(proto, accounts_protos_plan_dto_pb);
goog.exportSymbol('proto.accounts.protos.CreateSessionRequest', null, global);
goog.exportSymbol('proto.accounts.protos.SessionResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accounts.protos.CreateSessionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accounts.protos.CreateSessionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accounts.protos.CreateSessionRequest.displayName = 'proto.accounts.protos.CreateSessionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accounts.protos.SessionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accounts.protos.SessionResponse.repeatedFields_, null);
};
goog.inherits(proto.accounts.protos.SessionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accounts.protos.SessionResponse.displayName = 'proto.accounts.protos.SessionResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accounts.protos.CreateSessionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.accounts.protos.CreateSessionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accounts.protos.CreateSessionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.CreateSessionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    email: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    password: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accounts.protos.CreateSessionRequest}
 */
proto.accounts.protos.CreateSessionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accounts.protos.CreateSessionRequest;
  return proto.accounts.protos.CreateSessionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accounts.protos.CreateSessionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accounts.protos.CreateSessionRequest}
 */
proto.accounts.protos.CreateSessionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accounts.protos.CreateSessionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accounts.protos.CreateSessionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accounts.protos.CreateSessionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.CreateSessionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * required string email = 1;
 * @return {string}
 */
proto.accounts.protos.CreateSessionRequest.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.CreateSessionRequest} returns this
 */
proto.accounts.protos.CreateSessionRequest.prototype.setEmail = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.CreateSessionRequest} returns this
 */
proto.accounts.protos.CreateSessionRequest.prototype.clearEmail = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.CreateSessionRequest.prototype.hasEmail = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * required string password = 2;
 * @return {string}
 */
proto.accounts.protos.CreateSessionRequest.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.CreateSessionRequest} returns this
 */
proto.accounts.protos.CreateSessionRequest.prototype.setPassword = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.CreateSessionRequest} returns this
 */
proto.accounts.protos.CreateSessionRequest.prototype.clearPassword = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.CreateSessionRequest.prototype.hasPassword = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accounts.protos.SessionResponse.repeatedFields_ = [3,8,9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accounts.protos.SessionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.accounts.protos.SessionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accounts.protos.SessionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.SessionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    statusCode: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    user: (f = msg.getUser()) && accounts_protos_user_dto_pb.UserDTO.toObject(includeInstance, f),
    pangolinsList: jspb.Message.toObjectList(msg.getPangolinsList(),
    accounts_protos_pangolin_dto_pb.PangolinDTO.toObject, includeInstance),
    userError: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
    passwordError: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
    csrfToken: (f = jspb.Message.getField(msg, 7)) == null ? undefined : f,
    paymentsList: jspb.Message.toObjectList(msg.getPaymentsList(),
    accounts_protos_payment_dto_pb.PaymentDTO.toObject, includeInstance),
    invoicesList: jspb.Message.toObjectList(msg.getInvoicesList(),
    accounts_protos_invoice_dto_pb.InvoiceDTO.toObject, includeInstance),
    prices: (f = msg.getPrices()) && accounts_protos_plan_dto_pb.PricesDTO.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accounts.protos.SessionResponse}
 */
proto.accounts.protos.SessionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accounts.protos.SessionResponse;
  return proto.accounts.protos.SessionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accounts.protos.SessionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accounts.protos.SessionResponse}
 */
proto.accounts.protos.SessionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setStatusCode(value);
      break;
    case 2:
      var value = new accounts_protos_user_dto_pb.UserDTO;
      reader.readMessage(value,accounts_protos_user_dto_pb.UserDTO.deserializeBinaryFromReader);
      msg.setUser(value);
      break;
    case 3:
      var value = new accounts_protos_pangolin_dto_pb.PangolinDTO;
      reader.readMessage(value,accounts_protos_pangolin_dto_pb.PangolinDTO.deserializeBinaryFromReader);
      msg.addPangolins(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserError(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPasswordError(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setCsrfToken(value);
      break;
    case 8:
      var value = new accounts_protos_payment_dto_pb.PaymentDTO;
      reader.readMessage(value,accounts_protos_payment_dto_pb.PaymentDTO.deserializeBinaryFromReader);
      msg.addPayments(value);
      break;
    case 9:
      var value = new accounts_protos_invoice_dto_pb.InvoiceDTO;
      reader.readMessage(value,accounts_protos_invoice_dto_pb.InvoiceDTO.deserializeBinaryFromReader);
      msg.addInvoices(value);
      break;
    case 10:
      var value = new accounts_protos_plan_dto_pb.PricesDTO;
      reader.readMessage(value,accounts_protos_plan_dto_pb.PricesDTO.deserializeBinaryFromReader);
      msg.setPrices(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accounts.protos.SessionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accounts.protos.SessionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accounts.protos.SessionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.SessionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getUser();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      accounts_protos_user_dto_pb.UserDTO.serializeBinaryToWriter
    );
  }
  f = message.getPangolinsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      accounts_protos_pangolin_dto_pb.PangolinDTO.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getPaymentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      accounts_protos_payment_dto_pb.PaymentDTO.serializeBinaryToWriter
    );
  }
  f = message.getInvoicesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      accounts_protos_invoice_dto_pb.InvoiceDTO.serializeBinaryToWriter
    );
  }
  f = message.getPrices();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      accounts_protos_plan_dto_pb.PricesDTO.serializeBinaryToWriter
    );
  }
};


/**
 * required uint32 status_code = 1;
 * @return {number}
 */
proto.accounts.protos.SessionResponse.prototype.getStatusCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.accounts.protos.SessionResponse} returns this
 */
proto.accounts.protos.SessionResponse.prototype.setStatusCode = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.SessionResponse} returns this
 */
proto.accounts.protos.SessionResponse.prototype.clearStatusCode = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.SessionResponse.prototype.hasStatusCode = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional UserDTO user = 2;
 * @return {?proto.accounts.protos.UserDTO}
 */
proto.accounts.protos.SessionResponse.prototype.getUser = function() {
  return /** @type{?proto.accounts.protos.UserDTO} */ (
    jspb.Message.getWrapperField(this, accounts_protos_user_dto_pb.UserDTO, 2));
};


/**
 * @param {?proto.accounts.protos.UserDTO|undefined} value
 * @return {!proto.accounts.protos.SessionResponse} returns this
*/
proto.accounts.protos.SessionResponse.prototype.setUser = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accounts.protos.SessionResponse} returns this
 */
proto.accounts.protos.SessionResponse.prototype.clearUser = function() {
  return this.setUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.SessionResponse.prototype.hasUser = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated PangolinDTO pangolins = 3;
 * @return {!Array<!proto.accounts.protos.PangolinDTO>}
 */
proto.accounts.protos.SessionResponse.prototype.getPangolinsList = function() {
  return /** @type{!Array<!proto.accounts.protos.PangolinDTO>} */ (
    jspb.Message.getRepeatedWrapperField(this, accounts_protos_pangolin_dto_pb.PangolinDTO, 3));
};


/**
 * @param {!Array<!proto.accounts.protos.PangolinDTO>} value
 * @return {!proto.accounts.protos.SessionResponse} returns this
*/
proto.accounts.protos.SessionResponse.prototype.setPangolinsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.accounts.protos.PangolinDTO=} opt_value
 * @param {number=} opt_index
 * @return {!proto.accounts.protos.PangolinDTO}
 */
proto.accounts.protos.SessionResponse.prototype.addPangolins = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.accounts.protos.PangolinDTO, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accounts.protos.SessionResponse} returns this
 */
proto.accounts.protos.SessionResponse.prototype.clearPangolinsList = function() {
  return this.setPangolinsList([]);
};


/**
 * optional string user_error = 4;
 * @return {string}
 */
proto.accounts.protos.SessionResponse.prototype.getUserError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.SessionResponse} returns this
 */
proto.accounts.protos.SessionResponse.prototype.setUserError = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.SessionResponse} returns this
 */
proto.accounts.protos.SessionResponse.prototype.clearUserError = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.SessionResponse.prototype.hasUserError = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string password_error = 5;
 * @return {string}
 */
proto.accounts.protos.SessionResponse.prototype.getPasswordError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.SessionResponse} returns this
 */
proto.accounts.protos.SessionResponse.prototype.setPasswordError = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.SessionResponse} returns this
 */
proto.accounts.protos.SessionResponse.prototype.clearPasswordError = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.SessionResponse.prototype.hasPasswordError = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string csrf_token = 7;
 * @return {string}
 */
proto.accounts.protos.SessionResponse.prototype.getCsrfToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.SessionResponse} returns this
 */
proto.accounts.protos.SessionResponse.prototype.setCsrfToken = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.SessionResponse} returns this
 */
proto.accounts.protos.SessionResponse.prototype.clearCsrfToken = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.SessionResponse.prototype.hasCsrfToken = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * repeated PaymentDTO payments = 8;
 * @return {!Array<!proto.accounts.protos.PaymentDTO>}
 */
proto.accounts.protos.SessionResponse.prototype.getPaymentsList = function() {
  return /** @type{!Array<!proto.accounts.protos.PaymentDTO>} */ (
    jspb.Message.getRepeatedWrapperField(this, accounts_protos_payment_dto_pb.PaymentDTO, 8));
};


/**
 * @param {!Array<!proto.accounts.protos.PaymentDTO>} value
 * @return {!proto.accounts.protos.SessionResponse} returns this
*/
proto.accounts.protos.SessionResponse.prototype.setPaymentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.accounts.protos.PaymentDTO=} opt_value
 * @param {number=} opt_index
 * @return {!proto.accounts.protos.PaymentDTO}
 */
proto.accounts.protos.SessionResponse.prototype.addPayments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.accounts.protos.PaymentDTO, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accounts.protos.SessionResponse} returns this
 */
proto.accounts.protos.SessionResponse.prototype.clearPaymentsList = function() {
  return this.setPaymentsList([]);
};


/**
 * repeated InvoiceDTO invoices = 9;
 * @return {!Array<!proto.accounts.protos.InvoiceDTO>}
 */
proto.accounts.protos.SessionResponse.prototype.getInvoicesList = function() {
  return /** @type{!Array<!proto.accounts.protos.InvoiceDTO>} */ (
    jspb.Message.getRepeatedWrapperField(this, accounts_protos_invoice_dto_pb.InvoiceDTO, 9));
};


/**
 * @param {!Array<!proto.accounts.protos.InvoiceDTO>} value
 * @return {!proto.accounts.protos.SessionResponse} returns this
*/
proto.accounts.protos.SessionResponse.prototype.setInvoicesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.accounts.protos.InvoiceDTO=} opt_value
 * @param {number=} opt_index
 * @return {!proto.accounts.protos.InvoiceDTO}
 */
proto.accounts.protos.SessionResponse.prototype.addInvoices = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.accounts.protos.InvoiceDTO, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accounts.protos.SessionResponse} returns this
 */
proto.accounts.protos.SessionResponse.prototype.clearInvoicesList = function() {
  return this.setInvoicesList([]);
};


/**
 * optional PricesDTO prices = 10;
 * @return {?proto.PricesDTO}
 */
proto.accounts.protos.SessionResponse.prototype.getPrices = function() {
  return /** @type{?proto.PricesDTO} */ (
    jspb.Message.getWrapperField(this, accounts_protos_plan_dto_pb.PricesDTO, 10));
};


/**
 * @param {?proto.PricesDTO|undefined} value
 * @return {!proto.accounts.protos.SessionResponse} returns this
*/
proto.accounts.protos.SessionResponse.prototype.setPrices = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accounts.protos.SessionResponse} returns this
 */
proto.accounts.protos.SessionResponse.prototype.clearPrices = function() {
  return this.setPrices(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.SessionResponse.prototype.hasPrices = function() {
  return jspb.Message.getField(this, 10) != null;
};


goog.object.extend(exports, proto.accounts.protos);
